import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListBullets1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "list-bullets-1" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 3.748,
			x2: 23.25,
			y2: 3.748
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 12.748,
			x2: 23.25,
			y2: 12.748
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 21.748,
			x2: 23.25,
			y2: 21.748
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: .748,
			width: 4.5,
			height: 4.5,
			rx: .75,
			ry: .75
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: 9.748,
			width: 4.5,
			height: 4.5,
			rx: .75,
			ry: .75
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: 18.748,
			width: 4.5,
			height: 4.5,
			rx: .75,
			ry: .75
		})
	]
});
export default SvgListBullets1;
